import React, { forwardRef, useMemo } from 'react';
import classnames from 'classnames';

import { RSCheckBox, RSCheckBoxProps } from '../RSCheckBox';

export type RSCheckBoxWithLabelProps = RSCheckBoxProps & {
  labelText: string;
};

export const RSCheckBoxWithLabel = forwardRef<
  HTMLInputElement,
  RSCheckBoxWithLabelProps
>(({ labelText, ...props }, ref) => {
  const { disabled, readOnly } = props;
  const isDisabled = useMemo(() => {
    return disabled || readOnly;
  }, [disabled, readOnly]);

  return (
    <div className="inline-block">
      <label
        className={classnames(
          'flex',
          'items-center',
          !isDisabled ? 'cursor-pointer' : 'cursor-not-allowed',
        )}
      >
        {/* インライン要素のline-heightをなくすためfont-sizeを0に設定 */}
        <div className="flex-none text-[0px]">
          <RSCheckBox {...props} ref={ref} />
        </div>
        <div className="rs-font font-gray-1000 text-16 pc:text-15 ml-1 font-normal">
          {labelText}
        </div>
      </label>
    </div>
  );
});
